import React, { FunctionComponent, ChangeEvent } from 'react'
import { INPUT_TYPE } from '~/types'
import { Label, StyledInput } from './styles'

interface Props {
  id: string
  inputClasses?: string
  inputType: INPUT_TYPE
  label?: string
  labelClasses?: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  required?: boolean
  value: string
}

const Input: FunctionComponent<Props> = ({
  id,
  inputClasses = '',
  inputType,
  label = '',
  labelClasses = '',
  onChange,
  required = false,
  value,
}: Props) => (
  <>
    <StyledInput
      className={`input border border-gray-400 appearance-none rounded w-full px-3 pb-3 pt-6 focus focus:border-brand-600 focus:outline-none active:outline-none active:border-indigo-600 ${inputClasses}`}
      id={id}
      type={inputType}
      value={value}
      onChange={onChange}
      required={required}
    />
    {label && (
      <Label
        htmlFor={id}
        className={`absolute mb-0 -mt-2 pt-4 pl-3 leading-tighter text-gray-400 text-base mt-2 cursor-text label ${labelClasses}`}
      >
        {label}
      </Label>
    )}
  </>
)

export default Input
